import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { OfferOptionsContext } from "@gp/components";
import { EventOffer, SportOffer } from "@gp/offer";
import { useFormatTennisGameScore } from "@hooks";
import { observer } from "mobx-react";

export const GameScore = observer(function GameScore(props: {
	sport: SportOffer;
	event: EventOffer;
}) {
	const { t } = useTranslation();
	const gameScore = useFormatTennisGameScore(props.event, props.sport);
	const offerOptionsContext = useContext(OfferOptionsContext);

	// @ts-expect-error
	if (!gameScore || (offerOptionsContext.isHistoryEvent?.(props.event.id) ?? false)) {
		return null;
	}

	return (
		<div className="event__stats__item">
			<div className="event__stats__label">{t("EVENT.DETAILS.GAME")}</div>
			<div className="event__stats__value">
				<span>{gameScore.home}</span>
				<span> - </span>
				<span>{gameScore.away}</span>
			</div>
		</div>
	);
});
